import { setToolCursorBadge } from './tool-cursor-badge';
import { Logger } from './logger';
const console = new Logger('EditorEditTools');
const TOOL_BUTTON_IDS = {
    text: 'editor-tool-text',
    select: 'editor-tool-select',
    pen: 'editor-tool-pen',
    insert: 'editor-tool-insert',
    convert: 'editor-tool-convert',
    cut: 'editor-tool-cut'
};
function getEmptySnapshot() {
    return {
        isEditMode: false,
        stickyTool: 'select',
        highlightedTool: 'text',
        availability: {
            text: true,
            select: false,
            pen: false,
            insert: false,
            convert: false,
            cut: false
        },
        pointerBadge: null
    };
}
function readSnapshot() {
    const outlineEditor = window.glyphCanvas?.outlineEditor;
    if (!outlineEditor?.getEditToolUiSnapshot) {
        return getEmptySnapshot();
    }
    return outlineEditor.getEditToolUiSnapshot();
}
function applySnapshot(snapshot) {
    Object.keys(TOOL_BUTTON_IDS).forEach((toolId) => {
        const button = document.getElementById(TOOL_BUTTON_IDS[toolId]);
        if (!button) {
            return;
        }
        const available = toolId === 'text' ? true : snapshot.availability[toolId];
        const isActive = snapshot.highlightedTool === toolId;
        if (toolId === 'text') {
            button.disabled = false;
            button.classList.toggle('unavailable', false);
        }
        else {
            button.disabled = !snapshot.isEditMode || !available;
            button.classList.toggle('unavailable', !snapshot.isEditMode || !available);
        }
        button.classList.toggle('active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
    });
    setToolCursorBadge(snapshot.pointerBadge);
}
export function refreshEditorEditToolsUi() {
    applySnapshot(readSnapshot());
}
const TOOL_FLASH_CLASS = 'tool-flash';
export function flashEditorEditToolButton(toolId) {
    const buttonId = TOOL_BUTTON_IDS[toolId];
    if (!buttonId) {
        return;
    }
    const button = document.getElementById(buttonId);
    if (!button) {
        return;
    }
    button.classList.remove(TOOL_FLASH_CLASS);
    // Restart the CSS animation when the same tool is re-triggered.
    void button.offsetWidth;
    button.classList.add(TOOL_FLASH_CLASS);
    const onEnd = (event) => {
        if (event.target !== button) {
            return;
        }
        button.classList.remove(TOOL_FLASH_CLASS);
        button.removeEventListener('animationend', onEnd);
    };
    button.addEventListener('animationend', onEnd);
}
function handleToolButtonClick(toolId) {
    const outlineEditor = window.glyphCanvas?.outlineEditor;
    const glyphCanvas = window.glyphCanvas;
    if (!outlineEditor || !glyphCanvas) {
        return;
    }
    if (toolId === 'text') {
        if (outlineEditor.active) {
            void outlineEditor.requestExitGlyphEditMode();
        }
        refreshEditorEditToolsUi();
        return;
    }
    if (!outlineEditor.active) {
        return;
    }
    outlineEditor.setActiveEditTool(toolId);
    glyphCanvas.canvas?.focus();
    refreshEditorEditToolsUi();
}
function initEditorEditToolsUi() {
    const toolsRoot = document.getElementById('editor-edit-tools');
    if (!toolsRoot) {
        return;
    }
    Object.keys(TOOL_BUTTON_IDS).forEach((toolId) => {
        const button = document.getElementById(TOOL_BUTTON_IDS[toolId]);
        if (!button) {
            return;
        }
        button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            if (button instanceof HTMLButtonElement && button.disabled) {
                return;
            }
            handleToolButtonClick(toolId);
        });
    });
    window.addEventListener('editorModeChanged', () => {
        refreshEditorEditToolsUi();
    });
    window.addEventListener('editorEditToolsChanged', () => {
        refreshEditorEditToolsUi();
    });
    window.addEventListener('editorEditToolFlash', ((event) => {
        const toolId = event.detail?.toolId;
        if (!toolId || !(toolId in TOOL_BUTTON_IDS)) {
            return;
        }
        flashEditorEditToolButton(toolId);
    }));
    refreshEditorEditToolsUi();
    console.log('Editor edit tools initialized');
}
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEditorEditToolsUi);
}
else {
    initEditorEditToolsUi();
}
